import { LitElement, html} from 'lit';
import { EventManager } from '../../utilities/events';

export class AllInLogout extends LitElement {
  
    connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        setTimeout(()=>{
            this.eventManager.emit('allin-login', {loggedOut: true});
        }, 100);

        document.cookie = "allin_uid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
    }

    render() {
        return html`<slot></slot>`;
    }
}


